'use client';

import { ChevronLeft } from '@/components/icons/ChevronLeft';
import { useWizardNavigation } from '../hooks/useWizardNavigation';

interface WizardMobileBackButtonProps {
  dark?: boolean;
}

export const WizardMobileBackButton = ({
  dark = false,
}: WizardMobileBackButtonProps) => {
  const { hasPreviousStep, goToPreviousStep } = useWizardNavigation();

  if (!hasPreviousStep) return null;

  return (
    <div className='flex w-full items-start pb-6 md:hidden'>
      <button
        type='button'
        onClick={goToPreviousStep}
        className={`flex items-center gap-2 px-4 py-3 text-lg ${dark ? 'text-white' : 'text-[#292722]'}`}
      >
        <ChevronLeft className='h-[18px] w-[10px]' />
        Back
      </button>
    </div>
  );
};
